import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { type RootStateI } from "../index";

export interface ControllerStateI {
  colorKey: "primary" | "secondary" | "tertiary" | "background" | "accent" | "";
  logoColor: Record<string, string>;
}

const initialState: ControllerStateI = {
  colorKey: "",
  logoColor: {}
};

export const useColorKeySelector = () => {
  return useSelector((state: RootStateI) => state.controller.colorKey);
};

const controllerSlice = createSlice({
  name: "controller",
  initialState,
  reducers: {
    setColorKey: (state, action) => {
      state.colorKey = action.payload;
    },
    setLogoColorSelector: (state, action) => {
      state.logoColor = action.payload;
    }
  }
});

export default controllerSlice.reducer;
export const { setColorKey, setLogoColorSelector } = controllerSlice.actions;
